import { useQuery } from "@tanstack/react-query";

import { settingsApi } from "api/settingsApi";

// Per-tenant default SMS sender, edited on the Settings page.
const SMS_DEFAULT_SENDER_SETTING = "sms-default-sender";
// Used while the settings load, and when the setting is empty or missing (an API without it).
const FALLBACK_SMS_SENDER = "SzkoleniaGW";

export const useSmsDefaultSender = () => {
  // Same query as the Settings page, so both share one cache entry.
  const { data, isLoading } = useQuery({
    queryKey: ["settings-list"],
    queryFn: () => settingsApi.getSettingsList(),
  });
  const value = data?.data.find((s) => s.name === SMS_DEFAULT_SENDER_SETTING)?.value?.trim();

  return { defaultSender: value || FALLBACK_SMS_SENDER, isLoading };
};
